<template>
  <div class="recommend">
    <div class="recommend-left" @click="goBrainSummitTopic">
      <!-- 可能会再替换回来，勿删 -->
      <!-- <div class="knowledge">
        <div class="knowledge-title">知识问答</div>
        <div class="problem">
          {{ problem }}能吃{{ dataObj.name }}吗?
        </div>
        <div class="question-selection">
          <div class="no-eat" @click="canEat(3)">不能吃</div>
          <div class="can-eat" @click="canEat(0)">能吃</div>
        </div>
      </div> -->
    </div>
    <div class="recommend-right">
      <div class="star-Parenting">
        <!-- 可能会再替换回来，勿删 -->
        <!-- <img
          src="../../assets/images/home/powderedMilk-icon.png"
          @click="goPowderedMilk"
          alt=""
        /> -->
        <img
          src="../../assets/images/home/meng-shi-icon.png"
          @click="goMengShi"
          alt=""
        />
      </div>
      <div class="star-classroom">
        <!-- 可能会再替换回来，勿删 -->
        <!-- <img
          src="../../assets/images/home/startmom.png"
          @click="courseIndex"
          alt=""
        /> -->
        <img
          src="../../assets/images/home/quan-jia-icon.png"
          @click="goQuanJia"
          alt=""
        />
      </div>
      <!-- <div class="star-Parenting">
        <img
          src="../../assets/images/home/startbaby2.png"
          @click="calendarIndex"
          alt=""
        />
      </div> -->
    </div>
    <!-- 互动弹窗 -->
    <popup
      :show="popupShow"
      :answerObj="answerObj"
      @closePopup="closePopup"
    ></popup>
  </div>
</template>

<script>
import popup from "@/components/home/popup.vue"; //互动弹窗
import { BuiedPointClick_Fn, Exposurer_xmhH5_home_yuerrilicard_view } from "../../assets/js/BuriedPointEvent";
import { Debounce } from "../../assets/js/common";
export default {
  props: ["loginFlag", "editFlag", "babyDays", "tagId", "babyCurrentNum"],
  data() {
    return {
      problem: "", //根据当前的状态出问题
      tag_id: "5", //当前的状态
      dataObj: {}, //食物数据
      popupShow: false, //弹窗默认显示关闭
      answerObj: {}, //弹窗得内容
      canEatOnoff: false,
    };
  },
  components: {
    popup,
  },
  watch: {
    babyCurrentNum: {
    handler(newVal) {
      // Debounce(function(){
        this.getProblemByState();
      // })
    }
    },
    babyDays: {
      handler(newVal) {
        // Debounce(function(){
          this.getProblemByState();
        // })
      },
      deep: true,
    },
    tagId: {
      handler(newVal) {
        console.log(this.tag_id,'this.tag_id');
        // Debounce(function(){
        this.tag_id = newVal
        this.getProblemByState(); //监听状态的变化  有三种状态  备孕 怀孕 宝宝
        // })
      },
      deep: true,
      immediate: true,
    },
  },
  mounted(){
    Exposurer_xmhH5_home_yuerrilicard_view.observe("xmhH5_home_yuerrilicard_view", ".star-Parenting", false)
  },
  methods: {
    // 关闭问答弹窗
    closePopup() {
      this.popupShow = false;
    },
    //获取能不能吃的问题
    eatQuestion() {
      const stateTagId =  this.tag_id;
      //根据宝宝状态显示对应的问题
      this.$http.get(
        "/toolEat/getRandFoodName",
        { state: stateTagId == 6 ? 5 : stateTagId },
        (res) => {
          if (res.code == "200") {
            this.dataObj = res.data[0];
          }
        }
      );
    },
    /**
     * currentBabyInfo.tag_id == 1 ?
     *  '备孕' :
     * currentBabyInfo.tag_id == 2 ?
     *  '怀孕' : '育儿' }}
     */
    //跳往星妈课堂
    courseIndex() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_xmkt_click", {
        xmhh5_home_2nd_link: location.origin + '/course',
        xmhh5_home_2nd_name: '星妈课堂'
      });
      setTimeout(() => {
        this.$router.push({path:"/course",});
      }, 300);
    },
    //跳往育儿日历
    calendarIndex() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_mrxye_click");
      BuiedPointClick_Fn("xmhh5_home_mrxye_click", {
        xmhh5_home_3nd_link: location.origin + '/calendar?source=星妈会h5首页育儿日历卡片',
        xmhh5_home_3nd_name: '每日星育儿'
      });

      setTimeout(() => {
        this.$router.push({path:"/calendar",
          query:{
           source:"星妈会h5首页育儿日历卡片",
          }});
      }, 300);
    },
    //跳往育儿日历
    goPowderedMilk() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_xmkt_click", {
        xmhh5_home_2nd_link: location.origin + '/powderedMilk',
        xmhh5_home_2nd_name: '奶粉百科'
      });
      setTimeout(() => {
        this.$router.push({path:"/powderedMilk"})
      }, 300);
    },
    // 跳转脑峰会专题页
    goBrainSummitTopic() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_xmkt_click", {
        xmhh5_home_2nd_link: location.origin + '/brainSummitTopic',
        xmhh5_home_2nd_name: '脑峰会专题'
      });
      setTimeout(() => {
        this.$router.push({path:"/brainSummitTopic"})
      }, 300);
    },
    // 跳转蒙氏测评
    goMengShi() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_xmkt_click", {
        xmhh5_home_2nd_link: 'https://congmingbaobao.feihe.com/',
        xmhh5_home_2nd_name: '蒙氏测评'
      });
      setTimeout(() => {
        location.href = 'https://congmingbaobao.feihe.com/'
      }, 300);
    },
    // 跳转全家测评
    goQuanJia() {
      // 埋点
      BuiedPointClick_Fn("xmhh5_home_xmkt_click", {
        xmhh5_home_2nd_link: 'https://202403ceping.feihe.com/works/index',
        xmhh5_home_2nd_name: '全家测评'
      });
      setTimeout(() => {
        location.href = 'https://202403ceping.feihe.com/works/index'
      }, 300);
    },
    //获取能不能吃食物投票结果
    canEat(state){
      if(this.canEatOnoff) return;
      this.canEatOnoff = true;
      const that = this;
      if(!that.dataObj.id) {
        that.$toast({
          duration: 2000,
          message: "未获取到食物",
          context: that
        })
      };
      const stateTagId = that.tag_id;
      that.$http.post(
        "/foodquestion/addFoodQuestion",
        {},
        {
          foodId: that.dataObj.id,//食物名的id
          name: that.dataObj.name,//食物名
          state: stateTagId == 6 ? 5 : stateTagId, //当状态为6时，就走5
          answer: state,//
        },
        (res) => {
          if (res.code == "200") {
            // 获取问题答案与解析
            let allNum =
              (res.data.foodFalseNum /
                (res.data.foodFalseNum + res.data.foodTrueNum)) *
                100 +
              "%";
            that.answerObj = Object.assign(that.dataObj, res.data, {
              answer: state,
              problem: that.problem,
              allNum: allNum,
            });
            const { preganecy, answer } = that.answerObj;
            this.canEatOnoff = false;
            that.popupShow = true;
            // 埋点
            BuiedPointClick_Fn("xmhh5_home_zswd_click", {
              xmhh5_home_zswd_foodname: that.dataObj.name,
              xmhh5_home_zswd_isright: preganecy === answer ? "正确" : "错误",
            });
          }
        }
      );
    },
    //状态
    getProblemByState() {
      // 如果登录并定制过宝宝就为状态5
      // console.log(this,this.loginFlag,this.editFlag,'142');
      if (this.loginFlag && this.editFlag) {
        // 判断状态为1为备孕 2为孕期
        this.problem =
          (this.tagId == 1 && "备孕") || (this.tagId == 2 && "孕期");
          // 如果不是1也不是2就状态走育儿，育儿分为月子期，哺乳期，和‘**月的宝宝’
        if (this.tagId != 1 && this.tagId != 2) {
          let currentBabyMonth =
            this.babyCurrentNum == 1
              ? this.babyDays.firsttime
              : this.babyDays.secondtime;
          if (!currentBabyMonth) return;
          if (currentBabyMonth.includes("岁")) {
            this.problem = currentBabyMonth + "的宝宝";
          } else {
            let age = currentBabyMonth.split("月")[0]; // 当前宝宝的月份
            // 小于1就是月子期，传状态是3 月子期
            if (age < 1) {
              this.problem = "月子期";
              this.tag_id = 3;
              //大于等于1，小于6传状态4 哺乳区
            } else if (age >= 1 && age < 6) {
              this.problem = "哺乳期";
              this.tag_id = 4;
            } else {
              //超出这两个的  就传多少月的宝宝
              this.problem = currentBabyMonth + "的宝宝";
            }
          }
        }
      } else {
        this.tag_id = 5;
        this.problem = "宝宝";
      }
      //获取能不能吃的问题
      this.eatQuestion();
    },
  },
}
</script>

<style lang="less" scoped>
.recommend {
  display: flex;
  margin: 15px 17px 0px;
  .recommend-left {
    width: 168px;
    height: 154px;
    // background: #ffffff url("../../assets/images/home/question.png") no-repeat 84px
    //   3px;
    // background-size: 76px 73px;
    background-image: url('../../assets/images/home/brain-summit-topic-icon.png');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    border-radius: 10px;
    .knowledge {
      padding: 14px 12px 0px;
      .knowledge-title {
        font-size: 16px;
        line-height: 18px;
        font-weight: 600;
        color: #333333;
      }
    }
    .problem {
      width: 151px;
      margin-top: 10px;
      font-size: 16px;
      line-height: 23px;
      font-weight: 600;
      color: #666666;
    }
    .question-selection {
      display: flex;
      justify-content: space-between;
      text-align: center;
      align-items: center;
      position: absolute;
      bottom: 12px;
      div {
        width: 76px;
        height: 29px; /* 宽高 */
        background-color: #7762ff; /* 颜色 */
        text-align: center;
        color: #ffffff;
        font-size: 12px;
        line-height: 29px;
        font-weight: 500;
      }
      .no-eat {
        border-radius: 18px 0px 0px 18px;
        clip-path: polygon(0 0, 100% 0, 88% 100%, 0% 100%);
      }
      .can-eat {
        margin-left: -8px;
        background-color: #f470be; /* 颜色 */
        border-radius: 0px 18px 18px 0;
        clip-path: polygon(12% 0, 200% 0, 100% 100%, 0% 100%);
      }
    }
  }
  .recommend-right {
    margin-left: 8px;
    margin-top: -7px;
    .star-classroom {
      width: 168px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .star-Parenting {
      width: 168px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>